import React, { useEffect, useState } from 'react' 
import { Form, Formik, ErrorMessage, Field, FormikValues } from 'formik'
import * as Yup from 'yup'
import { SMS_config_post_data, Addons, SMS_setting_post_data, sms_addons_update } from '../../../../../modules/auth/core/_requests'
import Swal from 'sweetalert2';


interface SMSdata {
    addon_id: string;
    addon_user_name: string;
    addon_password: string;
    addon_token: string;
    addon_website_url: string;
    addon_sender_id: string;
    addon_created_on: string;
    addon_status: string;
}

const SMSConfigure = () => {
    const addon_type = "sms"
    const [loading, setLoading] = useState(false)
    const [isLoading, setIsLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [addons, setAddons] = useState<SMSdata[]>([]);
    const [initialEditValues, setInitialEditValues] = useState(
        {
            addon_id: '',
            addon_user_name_upd: '',
            addon_password_upd: '',
            addon_sender_id_upd: '',
            addon_website_url_upd: '',
        }
    )
    const handleButtonClick = () => {
        setShowModal(true);
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const initialValues = {
        sms_user_name: '',
        sms_password: '',
        sms_sender_id: '',
        sms_website_url: '',
    }

    const validationSchema = Yup.object().shape({
        sms_user_name: Yup.string().required('User Name is required'),
        sms_password: Yup.string().required('Password is required'),
        sms_sender_id: Yup.string().required('SenderId is required'),
        sms_website_url: Yup.string().required('Website URL is required'),
    });

    const handleSubmit = async (values: any, actions: FormikValues) => {
        setLoading(true)
        try {
            const { data: auth } = await SMS_config_post_data(
                values.sms_user_name,
                values.sms_password,
                values.sms_sender_id,
                values.sms_website_url,
                addon_type
            );
            actions.resetForm();
            SMS_ADDON_GET("sms");
            setTimeout(() => {
                setLoading(false)
                setShowModal(false)
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Successfully Submitted',
                    showConfirmButton: true,
                    timer: 3000
                });
            }, 500); // 5000 milliseconds = 5 seconds
        }
        catch (error) {
            console.error('Error submitting form data:', error);
        }
    }

    const SMS_ADDON_GET = async (addon: any) => {
        try {
            const response = await Addons(addon);
            setAddons(response.data.addon_details);
            if (response.data.addon_details) {
                setIsLoading(false);
                const initialData = response.data.addon_details
                const addonMetaData = JSON.parse(initialData[0].addon_meta_data); 
                setInitialEditValues({
                    addon_id: initialData.length > 0 ? initialData[0].addon_id : '',
                    addon_user_name_upd: addonMetaData.sms_user_name,
                    addon_password_upd: addonMetaData.sms_password,
                    addon_website_url_upd: addonMetaData.sms_website_url,
                    addon_sender_id_upd: addonMetaData.sms_sender_id,
                })
            }
        } catch (error) {
            console.error('Error fetching members:', error);
        }
    };

    useEffect(() => {
        SMS_ADDON_GET("sms");
    }, []);

    const handleUpdateSubmit = async (values: any) => { 
        setLoading(true)
        try {
            const { data: auth } = await sms_addons_update(
                values.addon_id,
                values.addon_user_name_upd,
                values.addon_password_upd,
                values.addon_website_url_upd,
                values.addon_sender_id_upd,
                addon_type
            );
            // actions.resetForm();
            setShowModal(false)
            setTimeout(() => {
                setLoading(false)
                SMS_ADDON_GET("sms");
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Successfully Updated',
                    showConfirmButton: true,
                    timer: 3000
                });
            }, 500); // 5000 milliseconds = 5 seconds
        }
        catch (error) {
            console.error('Error submitting form data:', error);
        }
    }

    const initialValuesTo = {
        sms_to_mobile_number: '',
        sms_message: '',
    }

    const validationSchemaTo = Yup.object().shape({
        sms_to_mobile_number: Yup.string().matches(/^[0-9]{10}$/, 'Mobile number must be exactly 10 digits').required('To Mobile Number is required'),
        sms_message: Yup.string().required('Message is required'),
    });

    const handleSubmitTo = (values: any, actions: FormikValues) => {
        console.log(values)
    }

    const initialSettingsValues = {
        sms_admin_mobile_number: '',
        sms_whatsapp_notication: [],
    }

    const validationSettings = Yup.object().shape({
        sms_admin_mobile_number: Yup.string().matches(/^[0-9]{10}$/, 'Mobile number must be exactly 10 digits').required('Admin Mobile Number is required'),
        sms_whatsapp_notication: Yup.array().required('Notification is required').test('at-least-one-setting', 'Select at least one Notification', (value) => value && value.length > 0),
    });

    const handleSubmitSettings = async (values: any, actions: FormikValues) => { 
        setLoading(true)
        try {
            const postData = new FormData();
            postData.append('sms_whatsapp_notication', JSON.stringify(values.sms_whatsapp_notication));
            const { data: auth } = await SMS_setting_post_data(
                postData,
                values.sms_admin_mobile_number,
            );
            actions.resetForm();
            setTimeout(() => {
                setLoading(false)
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Successfully Submitted',
                    showConfirmButton: true,
                    timer: 3000
                });
            }, 500); // 5000 milliseconds = 5 seconds
        }
        catch (error) {
            console.error('Error submitting form data:', error);
        }
    }


    return (
        <>

            <div className="row">
                <div className='col-md-8 offset-md-2 card p-8'>
                    <h4 className='mb-5'>SMS Configuration</h4>
                    <ul className="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6">
                        <li className="nav-item">
                            <a
                                className="nav-link active"
                                data-bs-toggle="tab"
                                href="#kt_tab_pane_4"
                            >
                                Configuration
                            </a>
                        </li>

                        <li className="nav-item">
                            <a
                                className="nav-link"
                                data-bs-toggle="tab"
                                href="#kt_tab_pane_5"
                            >
                                Test
                            </a>
                        </li>

                        <li className="nav-item">
                            <a
                                className="nav-link"
                                data-bs-toggle="tab"
                                href="#kt_tab_pane_6"
                            >
                                Settings
                            </a>
                        </li>
                    </ul>

                    <div className="tab-content" id="myTabContent">
                        <div className="tab-pane fade show active" id="kt_tab_pane_4" role="tabpanel">

                            {isLoading ? (
                                <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            ) : (addons.length > 0 ? (
                                <>
                                    {showModal ? (
                                        <div>
                                            <Formik initialValues={initialEditValues} onSubmit={handleUpdateSubmit}>
                                                {() => (
                                                    <Form>
                                                        <div className="form-group">
                                                            <Field type="hidden" name="addon_id" className="form-control" />
                                                            <ErrorMessage name="addon_user_name" component="div" className="text-danger" />
                                                        </div>

                                                        <div className="form-group">
                                                            <label htmlFor="addon_user_name_upd" className='form-label mt-3 mb-3'>User Name</label>
                                                            <Field type="text" name="addon_user_name_upd" className="form-control" />
                                                            <ErrorMessage name="addon_user_name" component="div" className="text-danger" />
                                                        </div>

                                                        <div className="form-group">
                                                            <label className="form-label mt-3 mb-3" htmlFor="addon_password_upd" >Password</label>
                                                            <Field type="password" name="addon_password_upd" className="form-control" />
                                                            <ErrorMessage name="addon_password" component="div" className="text-danger" />
                                                        </div>

                                                        <div className="form-group">
                                                            <label className="form-label mt-3 mb-3" htmlFor="addon_website_url_upd" >Website URL</label>
                                                            <Field type="text" name="addon_website_url_upd" className="form-control" />
                                                            <ErrorMessage name="addon_website_url" component="div" className="text-danger" />
                                                        </div>

                                                        <div className="form-group">
                                                            <label className="form-label mt-3 mb-3" htmlFor="addon_sender_id_upd" >Sender Id</label>
                                                            <Field type="text" name="addon_sender_id_upd" className="form-control" />
                                                            <ErrorMessage name="addon_sender_id" component="div" className="text-danger" />
                                                        </div>

                                                        <div className='d-flex justify-content-end mt-5'>
                                                            <button type='submit' className='btn btn-primary' disabled={loading}>
                                                                {!loading && 'Submit'}
                                                                {loading && (
                                                                    <span className='indicator-progress' style={{ display: 'block' }}>
                                                                        Please wait...{' '}
                                                                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                                                    </span>
                                                                )}
                                                            </button>
                                                        </div>
                                                    </Form>
                                                )}
                                            </Formik>
                                        </div>
                                    ) : (
                                        <>

                                            <div className='d-flex justify-content-between align-items-center mt-10'>
                                                <div className="mb-10">
                                                    <h5 className='fw-bolder'>Configuration Details</h5>
                                                </div>
                                                <div>
                                                    <button className='btn btn-sm btn-primary' onClick={handleButtonClick}>
                                                        Edit
                                                    </button>
                                                </div>
                                            </div>
                                            <div className='row mb-7'>
                                                <label className='col-lg-4 fw-bold text-muted'>User Name</label>
                                                <div className='col-lg-8'>
                                                    <span className='fw-bolder fs-6 text-dark'>{}</span>
                                                </div>
                                            </div>
                                            <div className="row mb-7">
                                                <label className="col-lg-4 fw-bold text-muted">Password</label>
                                                <div className="col-lg-8">
                                                    {showPassword ? (
                                                        <span className="fw-bolder fs-6 text-dark">{initialEditValues.addon_password_upd}</span>
                                                    ) : (
                                                        <span className="fw-bolder fs-6 text-dark">
                                                            {Array(initialEditValues.addon_password_upd.length + 1).join('*')}
                                                        </span>
                                                    )}
                                                    <button
                                                        className="btn btn-link"
                                                        onClick={togglePasswordVisibility}
                                                    >
                                                        {showPassword ? (
                                                            <i className="bi bi-eye-fill fs-5 ms-5"></i>
                                                        ) : (
                                                            <i className="bi bi-eye-slash-fill fs-5 ms-5"></i>
                                                        )}
                                                    </button>
                                                </div>
                                            </div>
                                            <div className='row mb-7'>
                                                <label className='col-lg-4 fw-bold text-muted'>Website URL</label>
                                                <div className='col-lg-8'>
                                                    <span className='fw-bolder fs-6 text-dark'>{initialEditValues.addon_website_url_upd}</span>
                                                </div>
                                            </div>
                                            <div className='row mb-7'>
                                                <label className='col-lg-4 fw-bold text-muted'>Sender Id</label>
                                                <div className='col-lg-8'>
                                                    <span className='fw-bolder fs-6 text-dark'>{initialEditValues.addon_sender_id_upd}</span>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </>
                            ) :
                                <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
                                    {() => (
                                        <Form>
                                            <div className="form-group">
                                                <label htmlFor="sms_user_name" className='form-label mt-3 mb-3'>User Name</label>
                                                <Field type="text" name="sms_user_name" className="form-control" />
                                                <ErrorMessage name="sms_user_name" component="div" className="text-danger" />
                                            </div>

                                            <div className="form-group">
                                                <label className="form-label mt-3 mb-3" htmlFor="sms_password" >Password</label>
                                                <Field type="password" name="sms_password" className="form-control" />
                                                <ErrorMessage name="sms_password" component="div" className="text-danger" />
                                            </div>

                                            <div className="form-group">
                                                <label className="form-label mt-3 mb-3" htmlFor="sms_sender_id" >Sender Id </label>
                                                <Field type="text" name="sms_sender_id" className="form-control" />
                                                <ErrorMessage name="sms_sender_id" component="div" className="text-danger" />
                                            </div>

                                            <div className="form-group">
                                                <label className="form-label mt-3 mb-3" htmlFor="sms_website_url" >Website URL</label>
                                                <Field type="text" name="sms_website_url" className="form-control" />
                                                <ErrorMessage name="sms_website_url" component="div" className="text-danger" />
                                            </div>

                                            <div className='d-flex justify-content-end mt-5'>
                                                <button type='submit' className='btn btn-primary' disabled={loading}>
                                                    {!loading && 'Submit'}
                                                    {loading && (
                                                        <span className='indicator-progress' style={{ display: 'block' }}>
                                                            Please wait...{' '}
                                                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                                        </span>
                                                    )}
                                                </button>
                                            </div>
                                        </Form>
                                    )}
                                </Formik>
                            )}
                        </div>

                        <div className="tab-pane fade" id="kt_tab_pane_5" role="tabpanel">
                            <Formik validationSchema={validationSchemaTo} initialValues={initialValuesTo} onSubmit={handleSubmitTo}>
                                {() => (
                                    <Form>
                                        <div className="form-group">
                                            <label className="form-label mt-3 mb-3" htmlFor="sms_to_mobile_number" >To Mobile Number</label>
                                            <Field type="text" name="sms_to_mobile_number" className="form-control" />
                                            <ErrorMessage name="sms_to_mobile_number" component="div" className="text-danger" />
                                        </div>

                                        <div className="form-group">
                                            <label className="form-label mt-3 mb-3" htmlFor="sms_message" >Message</label>
                                            <Field type="text" name="sms_message" as="textarea" row={5} className="form-control" />
                                            <ErrorMessage name="sms_message" component="div" className="text-danger" />
                                        </div>

                                        <div className='d-flex justify-content-end mt-5'>
                                            <button type='submit' className='btn btn-primary' disabled={loading}>
                                                {!loading && 'Submit'}
                                                {loading && (
                                                    <span className='indicator-progress' style={{ display: 'block' }}>
                                                        Please wait...{' '}
                                                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                                    </span>
                                                )}
                                            </button>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>

                        <div className="tab-pane fade" id="kt_tab_pane_6" role="tabpanel">
                            <Formik validationSchema={validationSettings} initialValues={initialSettingsValues} onSubmit={handleSubmitSettings}>
                                {() => (
                                    <Form>
                                        <div className="form-group">
                                            <label className="form-label mt-3 mb-3" htmlFor="sms_admin_mobile_number" >Admin Mobile Number</label>
                                            <Field type="text" name="sms_admin_mobile_number" className="form-control" />
                                            <ErrorMessage name="sms_admin_mobile_number" component="div" className="text-danger" />
                                        </div>

                                        <label className="form-label mt-3 mb-3">Notifications</label>
                                        <div className="form-check form-check-custom form-check-solid mb-3">
                                            <Field type="checkbox" name="sms_whatsapp_notication" value="New Orders" className="form-check-input" id="New_orders" />
                                            <label className="form-check-label" htmlFor="New_orders">New Orders</label>
                                        </div>
                                        <div className="form-check form-check-custom form-check-solid mb-3">
                                            <Field type="checkbox" name="sms_whatsapp_notication" value="Completed Order" className="form-check-input" id="Completed_order" />
                                            <label className="form-check-label" htmlFor="Completed_order">Completed Order</label>
                                        </div>
                                        <div className="form-check form-check-custom form-check-solid mb-3">
                                            <Field type="checkbox" name="sms_whatsapp_notication" value="Pending Order" className="form-check-input" id="pending_order" />
                                            <label className="form-check-label" htmlFor="pending_order">Pending Order</label>
                                        </div>
                                        <ErrorMessage name="sms_whatsapp_notication" component="div" className="text-danger" />
                                        <div className='d-flex justify-content-end mt-5'>
                                            <button type='submit' className='btn btn-primary' disabled={loading}>
                                                {!loading && 'Submit'}
                                                {loading && (
                                                    <span className='indicator-progress' style={{ display: 'block' }}>
                                                        Please wait...{' '}
                                                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                                    </span>
                                                )}
                                            </button>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SMSConfigure